var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type)?_c('i',{class:'iconfont icon-' + _vm.type,style:('font-size:' + _vm.size + 'px;color:' + _vm.color + ';')}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }